import Opportunities from '../../containers_v2/opportunities/Opportunities';
import { Route } from '../Routes';

// listed in the sidebar under sales operations (FormsRoutes)
const OpportunitiesRoutes = (): Route[] => [
	{
		component: Opportunities,
		path: '/opportunities'
	}
];

export default OpportunitiesRoutes;
